import React, { useEffect, useState } from "react";
import { remCalc } from "../../utils/helpers";
import clsx from "clsx";
import { setLayersHidden } from "../../store/actions/map";
import { connect } from "react-redux";
import { Box, Button, Divider, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import MapSettingsPopover from "./MapSettingsPopover";

const useStyles = makeStyles(theme => ({
  controlBtn: {
    backgroundColor: "#fff",
    textTransform: "none",
    width: remCalc(40),
    height: remCalc(40),
    minWidth: 0,
    padding: 0,
    borderRadius: theme.spacing(0),
    "&:hover": {
      backgroundColor: "#EEE"
    }
  },
  zoomBtn: {
    height: remCalc(39)
  },
  buttonGroup: {
    borderRadius: theme.variables.borderRadius,
    backgroundColor: "#fff",
    boxShadow: theme.variables.boxShadow,
    display: "flex"
  },
  groupBtn: {
    color: "#5F6368",
    fontSize: theme.typography.body2.fontSize,
    minWidth: remCalc(40),
    height: remCalc(40),
    backgroundColor: "#fff",
    boxShadow: "none",
    textTransform: "none",
    "&.Mui-disabled": {
      backgroundColor: "fff",
      "& svg": {
        color: "inherit"
      }
    },
    "&:first-of-type ": {
      marginLeft: theme.spacing(0.5)
    },
    "&:last-of-type ": {
      marginRight: theme.spacing(0.5)
    },
    borderRadius: theme.spacing(0),
    "&:hover": {
      backgroundColor: "#EEE"
    }
  },
  shadow: {
    boxShadow: theme.variables.boxShadow
  },
  roundedLg: {
    borderRadius: theme.variables.borderRadius,
    overflow: "hidden"
  },
  noShadow: {
    boxShadow: "none"
  },
  bgWhite: {
    backgroundColor: "#fff"
  },
  divider: {
    margin: theme.spacing(0, 1.125),
    backgroundColor: "#EEE",
    opacity: 0.75
  },
  rightTransition: {
    right: "30px",
    transition: theme.transitions.create(["right"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  bottomButtonGroup: {
    bottom: "6rem"
  }
}));

function Controls({ refitServicesBounds, mapRef }) {
  const classes = useStyles();
  const [fullScreen, setFullScreen] = useState(false);

  // Toggle fullscreen
  const toggleFullScreen = () => {
    if (!fullScreen) {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
      setFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozExitFullScreen) {
        document.mozExitFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      setFullScreen(false);
    }
  };

  useEffect(() => {
    const fullscreenChange = e => {
      if (!document.fullscreenElement) setFullScreen(false);
    };

    document.addEventListener("fullscreenchange", fullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", fullscreenChange);
  }, []);

  return (
    <>
      {/* Top Right */}
      <Box
        position="absolute"
        top={remCalc(12)}
        right={32}
        className={classes.rightTransition}
        zIndex={401}
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
      >
        {/* Marker / Layer / Share buttons */}
        <Box
          className={classes.buttonGroup}
          variant="contained"
          size="small"
          aria-label="small contained button group"
          onChange={e => console.log(e)}
        >
          <MapSettingsPopover
            iconClass={classes.groupBtn}
            refitServicesBounds={refitServicesBounds}
          />
        </Box>
      </Box>

      {/* Bottom Right */}
      <Box
        position="absolute"
        right={40}
        className={clsx(classes.rightTransition, classes.bottomButtonGroup)}
        bottom={remCalc(32)}
        zIndex={401}
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
      >
        {/* Fullscreen button */}
        <Box
          component={Button}
          onClick={toggleFullScreen}
          className={clsx(
            classes.controlBtn,
            classes.shadow,
            classes.roundedLg
          )}
          variant="contained"
          id="map-fullScreenButton"
        >
          {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </Box>

        {/* Zoom buttons */}
        <Box
          className={clsx(classes.shadow, classes.bgWhite, classes.roundedLg)}
          display="flex"
          flexDirection="column"
          mt={1}
        >
          <Button
            onClick={() => {
              const lf = mapRef.current.leafletElement;
              const currentZoom = lf.getZoom();
              lf.setZoom(currentZoom + 1);
            }}
            className={clsx(
              classes.controlBtn,
              classes.noShadow,
              classes.zoomBtn
            )}
            variant="contained"
            id="map-zoomPlusButton"
          >
            <Box component={AddIcon} mt={0.5} />
          </Button>

          <Divider className={classes.divider} />

          <Button
            onClick={() => {
              const lf = mapRef.current.leafletElement;
              const currentZoom = lf.getZoom();
              lf.setZoom(currentZoom - 1);
            }}
            className={clsx(
              classes.controlBtn,
              classes.noShadow,
              classes.zoomBtn
            )}
            variant="contained"
            id="map-zoomMinusButton"
          >
            <Box component={RemoveIcon} mb={0.5} />
          </Button>
        </Box>
      </Box>
    </>
  );
}

const mapStateToProps = state => ({
  accountDrawerOpen: state.account.accountDrawerOpen
});

export default connect(mapStateToProps, {
  setLayersHidden
})(Controls);
